import React from 'react'
import customStyles from "../../../../../assets/styles/customStyles";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import { InputLabel, FormControl, NativeSelect, Button, Box } from "@mui/material";
import clsx from "clsx";
import { Row, Col } from "antd";
import dropDown from "../../../../Shared/components/Icons/dropDown";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AccordionComponent } from "../../../../Shared/components/AccordionComponent"



const GlobalAddressMerge = (props) => {
    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Younote Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Global Address Book', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.removeUnderline)}>
                <AccordionComponent
                    title={'Merge Records'}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off">

                            <Row align="top" gutter={30}>
                                <Col span={6}>
                                    <FormControl fullWidth

                                    >
                                        <InputLabel className={classes.textFieldLableColorCustom} variant="standard">
                                            Name
                                        </InputLabel>
                                        <NativeSelect
                                            IconComponent={dropDown}
                                            className={clsx(classes.dropDownBorder, classes.selectPadding)}
                                        >
                                            <option value={10}>Ten</option>
                                        </NativeSelect>
                                    </FormControl>
                                </Col>
                                <Col span={6} >
                                    <FormControl fullWidth

                                    >
                                        <InputLabel className={classes.textFieldLableColorCustom} variant="standard" >
                                            Email
                                        </InputLabel>
                                        <NativeSelect
                                            IconComponent={dropDown}
                                            className={clsx(classes.dropDownBorder, classes.selectPadding)}
                                        >
                                            <option value={10}>Ten</option>
                                        </NativeSelect>
                                    </FormControl>
                                </Col>
                                <Col span={6}>
                                    <FormControl fullWidth

                                    >
                                        <InputLabel className={classes.textFieldLableColorCustom} variant="standard">
                                            Phone Number
                                        </InputLabel>
                                        <NativeSelect
                                            IconComponent={dropDown}
                                            className={clsx(classes.dropDownBorder, classes.selectPadding)}
                                        >
                                            <option value={10}>Ten</option>
                                        </NativeSelect>
                                    </FormControl>
                                </Col>
                                <Col span={6} className={classes.textAlignRight} >
                                    <Button
                                        Key="yes"
                                        type="submit"
                                        color="primary"
                                        variant="contained"
                                        className={clsx(classes.modalBtn)}
                                    >
                                        Find</Button>
                                </Col>
                            </Row>
                            <Row gutter={30} className={clsx(classes.margin20t)}>
                                <Col span={6}>
                                    <FormControl fullWidth

                                    >
                                        <InputLabel className={classes.textFieldLableColorCustom} variant="standard">
                                            Address
                                        </InputLabel>
                                        <NativeSelect
                                            IconComponent={dropDown}
                                            className={clsx(classes.dropDownBorder, classes.selectPadding)}
                                        >
                                            <option value={10}>Ten</option>
                                        </NativeSelect>
                                    </FormControl>
                                </Col>
                                <Col span={6} >
                                    <FormControl fullWidth
                                    >
                                        <NativeSelect
                                            IconComponent={dropDown}
                                            className={clsx(classes.dropDownBorder, classes.margin25t, classes.selectPadding)}
                                        >
                                            <option value={10}>Ten</option>
                                        </NativeSelect>
                                    </FormControl>
                                </Col>
                            </Row>
                        </Box>
                    }
                />
                <AccordionComponent
                    title={'Search Results'}
                    component={
                        <>
                            <Row>
                                <Col span={24} className={classes.textAlignRight}>
                                    <Button
                                        Key="yes"
                                        type="submit"
                                        color="primary"
                                        variant="contained"
                                        className={clsx(classes.modalBtn)}
                                    >
                                        Merge</Button>
                                </Col>
                            </Row>
                            <Row >
                                <TableContainer className={classes.margin20t}>
                                    <Table className={clsx(classes.textAlignRight)}>
                                        <TableHead>
                                            <TableRow className={clsx(classes.textFieldLableColorCustom, classes.fonSize13)}>
                                                <TableCell>{'Name'}</TableCell>
                                                <TableCell>{'GAB Id'}</TableCell>
                                                <TableCell>{'Younote Id'}</TableCell>
                                                <TableCell>{'Phone Number'}</TableCell>
                                                <TableCell >{'Address'}</TableCell>
                                                <TableCell>{'Primary'}</TableCell>

                                            </TableRow>
                                        </TableHead>
                                    </Table>
                                </TableContainer>
                            </Row>
                        </>
                    }
                />
            </div>
        </React.Fragment>
    )
}
export default GlobalAddressMerge